export const BRANCH_SELECTOR_PAGE_SIZE = 50;
export const YML_FILE_NAME = 'bitbucket-pipelines.yml';
export const ALLOWED_PLAN_URL =
  'https://support.atlassian.com/bitbucket-cloud/docs/limitations-of-bitbucket-pipelines/';
export const DOCS_CUSTOM_PIPELINE_URL =
  'https://confluence.atlassian.com/x/14RVMw';
export const DOCS_SCHEDULED_PIPELINES =
  'https://confluence.atlassian.com/x/rqadNw';
export const MAX_SCHEDULED_PIPELINES = 50;
export const INCREASED_MAX_SCHEDULED_PIPELINES = 100;
export const ORIGIN = 'https://bitbucket.org';

export const QUARTZ_URL =
  'https://www.freeformatter.com/cron-expression-generator-quartz.html';
